import { render, staticRenderFns } from "./index.vue?vue&type=template&id=24f39f62"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=24f39f62&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../viewport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports